<script>
export default {
  props: {
    value: Array,
    datasource: Object,
    tableProps: Object,
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    let innerValue = this.value;
    return {
      localCallRefresh: this.callRefresh,
      innerValue,
    };
  },
  computed: {},
  watch: {
    innerValue: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
    value(newValue) {
      this.innerValue = newValue;
    },
  },
  methods: {
    refreshDatasourceIfNecessary() {
      if (this.localCallRefresh === true) {
        this.datasource.refresh();
        this.$emit('paginate');
      }
    },
    renderBoolean(h) {
      return h('v-icon');
    },
    renderSelectLink(h, item, components) {
      const _vm = this;
      return h(
        'a',
        {
          on: {
            click() {
              _vm.$emit('item-selected', item);
            },
          },
        },
        components,
      );
    },
    renderLinkTo(h, item, components) {
      const to = this.datasource.linkTo(item);
      return h(
        'router-link',
        {
          props: {
            to,
          },
        },
        components,
      );
    },
    renderCell(h, props, field) {
      const customTdProps = {};
      const components = [];
      const item = props.item;
      if (field.value === '_select') {
        components.push(this.renderSelectButton(h, item, 'edit'));
      } else if (field.value === '_add') {
        components.push(this.renderSelectButton(h, item, 'add_circle_outline'));
      } else if (field.value === '_link') {
        components.push(
          this.renderLinkTo(h, { item: item }, [h('v-icon', {}, ['link'])]),
        );
      } else if (field.value === '_alarms') {
        if (item[field.value]) {
          components.push(h('v-icon', {}, ['priority_high']));
        }
      } else if (field.value === '_delete') {
        components.push(this.renderButton(h, item, 'item-deleted', 'delete'));
      } else if (field.check) {
        components.push(
          h('input', {
            attrs: {
              type: 'checkbox',
              checked: item[field.value],
              disabled: true,
            },
          }),
        );
      } else {
        var text = null;
        if (typeof field.formatter === 'function') {
          text = field.formatter(h, item, item[field.value]);
        } else {
          text = this.getFieldValue(item, field.value);
          if (text && text.Label !== undefined) {
            // possibility to display a linkedObject
            text = item[field.value].Label;
          }
        }

        if (field.props !== undefined) {
          Object.assign(customTdProps, field.props);
        }

        if (field.linkTo) {
          var linkProperties = {
            item: item,
            linkUrl: field.linkUrl ? field.linkUrl : null,
            linkId: field.linkId
              ? this.getFieldValue(item, field.linkId)
              : null,
          };
          components.push(this.renderLinkTo(h, linkProperties, [text]));
        } else if (field.select) {
          components.push(this.renderSelectLink(h, item, [text]));
        } else {
          components.push(text);
        }
      }
      return h('td', customTdProps, components);
    },
    getFieldValue(item, path) {
      var index = path.indexOf('.');
      if (index === -1) {
        return item[path];
      } else {
        if (item[path.substring(0, index)]) {
          return this.getFieldValue(
            item[path.substring(0, index)],
            path.substring(index + 1),
          );
        } else {
          return null;
        }
      }
    },
  },
  render(h) {
    const _vm = this;
    const scopedSlots = {};
    Object.assign(scopedSlots, _vm.$scopedSlots);
    const datasource = _vm.datasource;
    if (!scopedSlots.headerCell) {
      scopedSlots.headerCell = props => {
        if (props.header.icon) {
          return h('v-icon', {}, [props.header.icon]);
        } else {
          return this.$t(props.header.text);
        }
      };
    }

    if (!scopedSlots.items) {
      scopedSlots.items = props => {
        return h(
          'tr',
          {
            attrs: {
              class: datasource.customRowClass
                ? datasource.customRowClass(props.item)
                : null,
            },
          },
          datasource.fields.map(f => _vm.renderCell(h, props, f)),
        );
      };
    }

    const progress = h(
      'v-progress-linear',
      {
        slot: 'progress',
        props: {
          indeterminate: true,
          color: 'accent',
        },
      },
      [],
    );
    // const footer = h('footer', { slot: 'footer',}, [_vm.$slots.footer]);

    return h(
      'v-data-table',
      {
        props: {
          'must-sort': true,
          headers: datasource.fields,
          items: datasource.items,
          page: datasource.pagination.page,
          itemsPerPage: datasource.pagination.rowsPerPage,
          sortBy: datasource.pagination.sortBy,
          sortDesc: datasource.pagination.descending,
          'server-items-length': datasource.totalRows,
          loading: datasource.loading,
          'no-data-text': datasource.args.noDataText
            ? datasource.args.noDataText
            : this.$t('noDataText'),
          'no-results-text': this.$t('dataIterator.noResultsText'),
          dense: datasource.dense,
          footerProps: {
            itemsPerPageOptions: [10, 20, 50, 100],
            'items-per-page-text': this.$t('dataTable.rowsPerPageText'),
          },
          showSelect: datasource.showSelect,
          ...this.tableProps,
        },
        scopedSlots: scopedSlots,
        on: {
          input: function(event) {
            _vm.innerValue = event;
          },
          'update:page': function(page) {
            datasource.pagination.page = page;
            _vm.refreshDatasourceIfNecessary();
          },
          'update:items-per-page': function(itemsPerPage) {
            datasource.pagination.rowsPerPage = itemsPerPage;
            _vm.refreshDatasourceIfNecessary();
          },
          'update:sort-by': function(sortBy) {
            datasource.pagination.sortBy = sortBy;
            _vm.refreshDatasourceIfNecessary();
          },
          'update:sort-desc': function(sortDesc) {
            datasource.pagination.descending = sortDesc;
            _vm.refreshDatasourceIfNecessary();
          },
          'click:row': function(item) {
            _vm.$emit('click:row', item);
          },
        },
      },
      [progress],
    );
  },
};
</script>

<style scoped>
table.v-table thead tr {
  height: 40px;
}

a > .theme--light.v-icon {
  color: inherit;
}

table.v-table tbody td {
  height: 32px !important;
}

.dense table.v-table tbody td,
.dense table.v-table thead th.column {
  padding: 0 10px;
}
</style>
